import { useLocation } from 'react-router-dom'


const FROM_OPTIONS = ['webview', 'app', 'web'] as const

const LANG_OPTIONS = ['es', 'en'] as const


interface I {
  from: typeof FROM_OPTIONS[number] | undefined
  lang: typeof LANG_OPTIONS[number] | undefined
}


const useQueryString = () => {

  const { search } = useLocation()
  const searchParams = new URLSearchParams(search)

  const from = FROM_OPTIONS.find(opt => opt === searchParams.get('from'))
  const lang = LANG_OPTIONS.find(opt => opt === searchParams.get('lang'))
  
  const data: I = {
    from,
    lang
  }

  return data
}

export default useQueryString